<template>
    <!--
        SEC-4093
        This product has been added to these pin tray(s), project(s), etc.
        - If this product hasn't been added to anything, the entire <ul> is not rendered.
        - They're listed chronologically, newest at the top.
            - Despite how it renders below, Favorites is NOT meant to always be at the top.
        - The Favorites item does not use the word "tray".
        - All other trays do use the word "tray".
        - Projects use the word "projects".
-->
    <ul class="border-t border-keyline-primary p-8 pt-6 space-y-3 text-v2-gray-80 text-sm dark:text-v2-gray-90" v-if="listItems?.length">
        <ListItem v-for="item in listItems" :tray="item" />
    </ul>
</template>
<script setup>
import {ListItem} from "@/Components";
import {onMounted, ref, inject} from "vue";
import {router} from "@inertiajs/vue3";
import {eventBus} from "@/Composables";

const route = inject("route");

const listItems = ref([1,2,3,4]);

const fetchRelationships = () => {
    axios.post(route('api.v1.public.account.pins.fetch_pin_trays', {
        pin_item: router.page.props.summary.item_reference_id
    }))
        .then((response) => {
            listItems.value = response.data.trays;
        })
        .catch((error) => {
            console.log("fetch ERROR:", error)
        })
}

onMounted(() => {
    fetchRelationships()
    eventBus.on("pins:trays-fetched", () => fetchRelationships());
})
</script>
